import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({ standalone: true, selector: '[awFileUploadDrop]' })
export class FileUploadDropDirective {
  @Input() defaultBgClass: string;

  @Input() hoveredBgClass: string;

  @Input() dropDisabled = false;

  @Output() filesDropped = new EventEmitter<FileList>();

  constructor(private readonly elementRef: ElementRef<HTMLDivElement>) {}

  private get classList(): DOMTokenList {
    return this.elementRef.nativeElement.classList;
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    this.stopEvent(event);

    if (!this.dropDisabled) {
      this.applyHoverColor();
    }
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    this.stopEvent(event);

    if (!this.dropDisabled) {
      this.removeHoverColor();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    this.stopEvent(event);

    if (!this.dropDisabled) {
      this.removeHoverColor();

      const files = event.dataTransfer?.files;

      if (files && files.length > 0) {
        this.filesDropped.emit(files);
      }
    }
  }

  private applyHoverColor(): void {
    const { classList } = this;

    classList.remove(this.defaultBgClass);
    classList.add(this.hoveredBgClass);
  }

  private removeHoverColor(): void {
    const { classList } = this;

    classList.remove(this.hoveredBgClass);
    classList.add(this.defaultBgClass);
  }

  private readonly stopEvent = (event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };
}
